import { useTranslation } from 'react-i18next';

export default function ContactInfo() {
  const { t } = useTranslation();

  const infoCards = [
    {
      icon: 'ri-map-pin-2-fill',
      title: t('contactPage.info1Title'),
      lines: ['Benelux — Bruxelles, Belgique', 'Maroc — Casablanca', 'Suisse — Genève', 'USA — Houston', 'UAE — Dubaï'],
      gradient: 'from-[#FF6B6B] to-[#FF8E53]',
    },
    {
      icon: 'ri-phone-fill',
      title: t('contactPage.info2Title'),
      lines: [
        '🇧🇪 +32 10 39 83 83',
        '🇨🇭 +41 22 562 42 48',
        '🇲🇦 +212 5 31 18 84 66',
        '🇺🇸 +1 832 295 0203',
        '🇦🇪 +971 58 514 6914'
      ],
      gradient: 'from-[#4ECDC4] to-[#44A08D]',
    },
    {
      icon: 'ri-mail-send-fill',
      title: t('contactPage.info3Title'),
      lines: ['Belgique@airbrs.com', 'Maroc@airbrs.com'],
      gradient: 'from-[#FF8E53] to-[#FF6B6B]',
    },
    {
      icon: 'ri-time-fill',
      title: t('contactPage.info4Title'),
      lines: [t('contactPage.info4Line1'), t('contactPage.info4Line2')],
      gradient: 'from-[#44A08D] to-[#4ECDC4]',
    },
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {infoCards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div
                className={`
                  w-12 h-12 
                  bg-gradient-to-br 
                  ${card.gradient} 
                  rounded-xl 
                  flex items-center justify-center 
                  mb-5
                `}
              >
                <i className={`${card.icon} text-white text-xl`}></i>
              </div>
              <h3
                className="text-base font-bold text-gray-900 mb-3"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {card.title}
              </h3>
              {card.lines.map((line, i) => (
                <p key={i} className="text-sm text-gray-500 leading-relaxed">
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
